export default "__VITE_ASSET__BJB9y2K4__"